<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      title="GIRO DE CARTEIRA"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-3">
          <label><small class="text-danger">*</small> {{$lang.RelationchipManager.Label}}:</label>
          <div class="input-group">

            <v-select v-model="form.funcionarioId.value"
                      :options="form.funcionarioId.options"
                      class="w-100"
                      label="text"
                      :reduce="(opt) => opt.value"
                      @input="searchHistory(form.funcionarioId.value)">
              <template v-slot:no-options>Nenhum funcionário encontrado.</template>
            </v-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtData"><small class="text-danger">*</small> Data:</label>
          <div class="input-group">
            <b-form-input type="date"
                          id="txtData"
                          name="txtData"
                          style="height: 35px;"
                          v-model="form.dtInicioGiroCarteira.value"
                          :required="form.dtInicioGiroCarteira.required"
                          :state="form.dtInicioGiroCarteira.state"/>
          </div>
        </div>
        <div class="col-md-3">
          <label ><small class="text-danger">*</small> Qtde. Visitas PF:</label>
          <div class="input-group">
            <b-form-input
              type="number"
              placeholder="Qtde Visitas PF"
              v-model="form.qtdVisitasPf.value"
              :required="form.qtdVisitasPf.required"
              :state="form.qtdVisitasPf.state"
            />
          </div>
        </div>
        <div class="col-md-3">
          <label ><small class="text-danger">*</small> Qtde. Visitas PJ:</label>
          <div class="input-group">
            <b-form-input
              type="number"
              placeholder="Qtde. Visitas PJ"
              v-model="form.qtdVisitasPj.value"
              :required="form.qtdVisitasPj.required"
              :state="form.qtdVisitasPj.state"
            />
          </div>
        </div>
      </div>
      <div align="center">
        <b-button v-b-toggle.historicoGerenteRelacionamentoAlteracao class="mt-1">Mostrar Alterações</b-button>
        <b-collapse id="historicoGerenteRelacionamentoAlteracao" class="pt-3">
          <div>
            <Tables
              ref="tableGrid"
              :columns="[
                'Data Alteração',
                'Responsável',
                'Data',
                'Qtde. Visitas PF',
                'Qtde. Visitas PJ',
              ]"
              :showTipFooter="false"
            >
              <tr v-for="obj in this.objList" v-bind:key="obj.id">
                <TableColumn
                  :IsDateOnly="true"
                  :status="1"
                  :value="obj.dataAlteracao ? obj.dataAlteracao : '-'"
                />
                <TableColumn
                  :IsText="true"
                  :status="1"
                  :value="obj.responsavel ? obj.responsavel : '-'"
                />
                <TableColumn
                  :IsDateOnly="true"
                  :status="1"
                  :value="obj.dtInicioGiroCarteira ? obj.dtInicioGiroCarteira : '-'"
                />
                <TableColumn
                  :IsText="true"
                  :status="1"
                  :value="obj.qtdVisitasPf ? obj.qtdVisitasPf.toString() : '-'"
                />
                <TableColumn
                  :IsText="true"
                  :status="1"
                  :value="obj.qtdVisitasPj ? obj.qtdVisitasPj.toString() : '-'"
                />
              </tr>
            </Tables>
          </div>
        </b-collapse>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import _ from 'lodash'
import AccountMixin from '@/store/module/account/mixin'
import { JWTService } from '@/shared/services/jwt'

import EmployeeRepository from '@/shared/http/repositories/configurations/employee'
import PARepository from '@/shared/http/repositories/configurations/pa'
import GiroCarteiraRepository from '@/shared/http/repositories/configurations/girocarteira.js'

import GiroCarteiraModel from '@/shared/models/configurations/girocarteiramodel.js'
import GiroCarteiraForm from './form.js'

export default {
  name: 'GiroCarteiraAdd',
  mixins: [
    ActionsForm,
    AccountMixin
  ],
  data () {
    return {
      form: _.cloneDeep(GiroCarteiraForm),
      data: _.cloneDeep(GiroCarteiraModel)
    }
  },
  mounted () {
    this.onLoadAgentesRelacionamento()
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoadAgentesRelacionamento () {
      loading.push()
      this.permissions = JWTService.GetRoles()
      if (this.hasRole(this.roles.ADMINISTRADOR)) {
        EmployeeRepository.GetAll()
          .then((res) => {
            this.form.funcionarioId.options = res.data.content.map((x) => ({'value': x.id, 'text': x.pessoa.nome}))
            loading.pop()
          })
          .catch(this.onException)
      } else {
        PARepository.GetAllByUser(JWTService.GetUserName())
          .then((res) => {
            loading.pop()
            this.form.funcionarioId.options = res.data.funcionarioDTOList.map((x) => ({'value': x.id, 'text': x.associado.pessoa.nome}))
          })
          .catch(this.onException)
      }
    },
    onEdit (obj) {
      loading.push()
      let edit = _.cloneDeep(obj)

      edit.dtInicioGiroCarteira = this.moment.utc(edit.dtInicioGiroCarteira).format('YYYY-MM-DD')
      edit.funcionarioId = edit.funcionario.id

      Tools.SetValueInForm(this.form, this.data, edit)
      this.searchHistory(this.form.funcionarioId.value)

      loading.pop()
    },
    onCreate () {
      loading.push()
      GiroCarteiraRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      GiroCarteiraRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    searchHistory (funcionarioId) {
      if (funcionarioId) {
        loading.push()
        GiroCarteiraRepository.GetAllHistoryByFuncionarioId(funcionarioId, this.$refs.tableGrid.pagingLimit ? this.$refs.tableGrid.pagingLimit : 10, this.$refs.tableGrid.pagingIndex ? this.$refs.tableGrid.pagingIndex : 0)
          .then((response) => {
            loading.close()
            this.onResultGrid(response)
          })
          .catch(this.onException)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/movimentacoes/giroCarteira/components/add/GiroCarteiraAdd.vue